import React from 'react';
import axios from 'axios';
import { styled } from "../../../stitches.config";
import { body, bodyLarge } from '../../commonStyles/Fonts';

interface TipFormProps {
    children: JSX.Element,
}

const TipForm = ({ children }: TipFormProps) => {

    const formSubmit = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.preventDefault();
        // Form fields
        let name = (document.getElementById('name') as HTMLInputElement)
        let email = (document.getElementById('email') as HTMLInputElement)
        let bio = (document.getElementById('bio') as HTMLInputElement)
        let message = (document.getElementById('message') as HTMLInputElement)
        name.value && email.value && bio.value && message.value ?
            axios.post(
                'https://natemat-staging.jadwiga.easysoftware.pl/api/tip-form', {
                name: name.value,
                email: email.value,
                bio: bio.value,
                message: message.value,
            }
            ).then((res) => {
                if (res.status == 200) {
                    name.value = "";
                    email.value = "";
                    bio.value = "";
                    message.value = "";
                }
            })
            : null;
    }

    return (
        <StyledTipForm id='tipform'>
            {children}
            <TipFormFieldset>
                <TipFormFieldsetItem>
                    <label htmlFor="" className={body()}>Imię i nazwisko</label>
                    <input type="text" name="name" placeholder='Wpisz swoje imię i nazwisko' className={bodyLarge()} id='name' required />
                </TipFormFieldsetItem>
                <TipFormFieldsetItem>
                    <label htmlFor="" className={body()}>Email</label>
                    <input type="email" name="email" placeholder='Wpisz swój email' className={bodyLarge()} id='email' required />
                </TipFormFieldsetItem>
                <TipFormFieldsetItem>
                    <label htmlFor="" className={body()}>Twoje bio (do 1000 znaków)</label>
                    <textarea name="bio" rows={5} maxLength={1000} placeholder='Opisz swoje bio' className={bodyLarge()} id='bio' required />
                </TipFormFieldsetItem>
                <TipFormFieldsetItem>
                    <label htmlFor="" className={body()}>W 1000 znaków albo mniej opisz nam swój pomysł</label>
                    <textarea name="message" rows={5} maxLength={1000} placeholder='Opisz swój pomysł' className={bodyLarge()} id='message' required />
                </TipFormFieldsetItem>
                <FormButton className={bodyLarge()} onClick={(e) => formSubmit(e)} type='submit'>Zaaplikuj do nas</FormButton>
            </TipFormFieldset>
        </StyledTipForm>
    )
}

export default TipForm;

const StyledTipForm = styled('div', {
    backgroundColor: '$grayscale100Fixed',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    color: '$grayscale0Fixed',
    gap: '40px',
    padding: '40px 16px',
    "@bp4": {
        gap: '84px',
        padding: '90px 168px 168px',
        flexDirection: 'row',
    }
})

const TipFormFieldset = styled('form', {
    display: 'flex',
    padding: '32px',
    flexDirection: 'column',
    backgroundColor: '$grayscale0',
    width: '100%',
    gap: '24px',
    '@bp4': {
        gap: '32px',
        padding: '56px',
        width: '600px',
    }
})

const TipFormFieldsetItem = styled('div', {
    display: 'flex',
    flexDirection: 'column',

    gap: '4px',
    label: {
        color: '$grayscale100',
    },
    textarea: {
        resize: 'none',
    },
    'input, textarea': {
        border: '1px solid $grayscale25',
        color: '$grayscale100',
        padding: '11px',
        '&::placeholder': {
            color: '$grayscale50',
        }
    }

})

const FormButton = styled('button', {
    background: '$primary',
    border: 'none',
    borderRadius: '0px',
    color: '$grayscale0Fixed',
    padding: '11px 20px',
    width: '100%',
    '@bp4': {
        width: 'fit-content',

    }
})